<template>
  <div id="main">
    <router-view />
  </div>
</template>
 
 <script>
export default {
  name: "app",
};
</script>
